import { render, staticRenderFns } from "./Saldos.vue?vue&type=template&id=4cb584e8&scoped=true&"
import script from "./Saldos.vue?vue&type=script&lang=js&"
export * from "./Saldos.vue?vue&type=script&lang=js&"
import style0 from "./Saldos.vue?vue&type=style&index=0&id=4cb584e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb584e8",
  null
  
)

export default component.exports